<template>
    <div>
        <section class="form-section">
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label" for="accounting_period">{{ trans('licenses.label.accounting_period') }}</label>
                    <select name="accounting_period" v-model="fields.accountingPeriod" :class="['form-select', {'form-select--error': errors('accounting_period')}]">
                        <option value="1">{{ trans('licenses.label.monthly') }}</option>
                        <option value="3">{{ trans('licenses.label.quarterly') }}</option>
                    </select>
                    <span class="invalid-feedback" v-if="errors('accounting_period')">
                        <strong>{{ errors('accounting_period') }}</strong>
                    </span>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="accounting_email"
                        :required="true"
                        type="email"
                        v-model="fields.accountingEmail"
                    >
                        {{ trans('licenses.label.accounting_email') }}
                    </form-input>
                </div>
            </div>
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">
                    {{ trans('buttons.submit') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'license',
        'client',
    ],

    data() {
        return {
            fields: {
                accountingPeriod: this.old('accounting_period', this.license.accounting_period) || "",
                accountingEmail: this.old('accounting_email', this.license.accounting_email),
            },
        };
    },
}
</script>
